import React, { forwardRef } from "react";
import { makeStyles, Container } from "@material-ui/core";
import BoardView from "../../../../components/MainComponent/BoardComponent/BoardView";
import TotalBoardComponent from "../../../../components/MainComponent/BoardComponent/TotalBoardComponent";


const useStyles = makeStyles((theme) => ({}));

interface BoardViewContainerProps {
  //   children: React.ReactNode | null | string | undefined;
  match: any;
  history: any;
}

function BoardViewContainer({ match, history }: BoardViewContainerProps) {
  const classes = useStyles();

  return (
    <Container >
     
      <BoardView match={match} history={history} />
      {/* <TotalBoardComponent /> */}
    </Container>
  );
}

export default BoardViewContainer;
